import { cs, de, enUS, es, fr, it, ja, ko, pl, ptBR, ro, ru, tr, vi, zhCN } from 'date-fns/locale';

export enum Language {
  English = 'en_US',
  Spanish = 'es_ES',
  German = 'de_DE',
  French = 'fr_FR',
  Romanian = 'ro_RO',
  Polish = 'pl_PL',
  Portuguese = 'pt_BR',
  Italian = 'it_IT',
  Russian = 'ru_RU',
  Czech = 'cs_CZ',
  Chinese = 'zh_CN',
  Korean = 'ko_KR',
  Turkish = 'tr_TR',
  Vietnamese = 'vi_VN',
  Japanese = 'ja_JP',
  Default = 'default',
}

// please check apps/webcomponents/src/utils/i18n.utils.js for the updated supported languages.
// We need to update this map every time a new language is added
export const languageMap = new Map<string, Locale>([
  [Language.English, enUS],
  [Language.French, fr],
  [Language.German, de],
  [Language.Spanish, es],
  [Language.Romanian, ro],
  [Language.Polish, pl],
  [Language.Portuguese, ptBR],
  [Language.Italian, it],
  [Language.Russian, ru],
  [Language.Czech, cs],
  [Language.Chinese, zhCN],
  [Language.Korean, ko],
  [Language.Turkish, tr],
  [Language.Vietnamese, vi],
  [Language.Japanese, ja],
  [Language.Default, enUS],
]);

export function getLocaleObjectFromUserLocale(userLocale: string): Locale {
  return languageMap.get(userLocale) || (languageMap.get('default') as Locale);
}

export function getLocalizedAsset<T = string>(
  dict: Partial<{ [language in Language]: T }> & { default: T },
  userLanguage: Language
): T {
  return dict[userLanguage] || dict[Language.Default];
}
